import React, { useContext } from 'react';
import { CellValue, ICell } from 'models/interfaces/spreadsheet-types/core-types';

export interface LedgerContextType {
  parentCell?: ICell;
  cells: Record<string, ICell>;
  setCells: (cells: Record<string, ICell>) => void;
  rows: any[];
  colConfig: any;
  exchangeRateMap?: any;
  showDeleteColumn?: boolean;
  disabled?: boolean;
  deleteRow?: (rowIndex: number) => void;
  onCellsChange: (changes: Array<{ cell: ICell; value: CellValue }>) => void;
}

const defaultLedgerContext: LedgerContextType = {
  cells: {},
  setCells: () => { },
  rows: [],
  colConfig: [],
  onCellsChange: () => { },
};

const LedgerContext = React.createContext<LedgerContextType>(defaultLedgerContext);

export const useLedgerContext = () => useContext(LedgerContext);

export default LedgerContext;
